import React from "react";
import "./LoadingData.scss";
import Loading from "../../SharedComponents/LoadingScreen/Loading";
import LoginFoot from "../../SharedComponents/LoginProcess/LoginFoot/LoginFoot";
import { Navigate } from "react-router-dom";
import { SelectHead } from "../../SharedComponents/LoginProcess/LoginHead/LoginHead";
import { useDispatch, useSelector } from "react-redux";
import { dashboardSelectedGraphs } from "../../Redux/actions";
import { loadDataForAllTabs } from "../../Redux/actions";
import EvaluationPanelController from "../Performance/PerformancePanels/EvaluationPanel/EvaluationPanelController";
import FinishedSessionsPanelController from "../BotActivity/BotActivityPanels/FinishedSessionsPanel/FinishedSessionsPanelController";
import GeographicalPanelController from "../BotActivity/BotActivityPanels/BlockedSessionsGeographyPanel/BlockedSessionsGeographyPanelController";
import BlockedBotsCo2Controller from "../BotActivity/BotActivityPanels/BlockedBotsCO2/BlockedBotsCo2Controller";
import BlockedSessionsGeographyPanelController from "../BotActivity/BotActivityPanels/BlockedSessionsGeographyPanel/BlockedSessionsGeographyPanelController";
import CurrentActivityPanelController from "../Today/TodayPanels/CurrentActivityPanel/CurrentActivityPanelController";
import TodayFinishedSessionsPanelController from "../Today/TodayPanels/TodayFinishedSessionsPanel/TodayFinishedSessionsPanelController";
import AffiliatesController from "../Affiliates/AffiliatesController";
import ManageCustomerData from "../../SharedComponents/ManageCustomerData/ManageCustomersData";
import HumanActivityPanel from "../../components/Performance/PerformancePanels/HumanActivityPanel/HumanActivityPanelController";
import BotDetailsData from "../Today/TodayPanels/BotDetails/BotDetailsData";
import BotTypeDescription from "../BotTypesDescription/BotTypeDescription";
import BotRiskController from "components/Today/TodayPanels/BotRisk/TodayBotRiskController";
import BotRiskControllerforBotActivity from "components/BotActivity/BotActivityPanels/BotRiskForBotActivity/BotRiskForBotActivityContoller";
import api from "../../veracityapi";
import { Adnetworks } from "components/AFP/Constants";
import bApi from "../../API/BeaconAPI";
import { useLocation } from "react-router-dom";
import "moment-timezone";
import AppMaintenance from "../Login/AppMaintenance/AppMaintenance";

const LoadingData = () => {
	if (!api.isUserLoggedIn()) {
		api.logout("Fatal Error")
	};
	const dispatch = useDispatch();
	const location = useLocation();
	const status = localStorage.getItem("version");
	const search = location.search.slice(1);
	const checkoutId = search.split("&")[0];
	localStorage.setItem('CheckoutID', checkoutId.split("=")[1]);
	const [reduxCompleteWTP, setReduxCompleteWTP] = React.useState(false);
	const [reduxCompleteAFP, setReduxCompleteAFP] = React.useState(false);
	const [requiredDataReady, setRequiredDataReady] = React.useState(false);
	const websiteGUID = localStorage.getItem("selected_site");
	const detectModes = { ...useSelector(state => state?.detectModes?.data) };
	const [addWebThreatAllow, setAddWebThreatAllow] = React.useState(null);
	const isAdmin = localStorage.getItem("admin") === "true";
	const isPartner = localStorage.getItem("isPartner") === "true";
	const websiteDetails = useSelector(state => state?.websiteDetails?.data?.websiteDetails);
	const { afp_status, wtp_status } = detectModes;
	const [statefailed, setStateFailed] = React.useState(false);
	const [loadingDots, setLoadingDots] = React.useState(1);
	// const [currentFetchCount, setCurrentFetchCount] = React.useState(0);
	// const [totalFetchCount, setTotalFetchCount] = React.useState(0);

	

	React.useEffect(() => {
		setAddWebThreatAllow(detectModes.wtp_status !== "off");
		setTimeout(() => {
			setLoadingDots((loadingDots % 3) + 1);
		}, 500);
	}, [])

	const getAFPWebsiteId = async () => {

		new Promise((resolve, reject) => {			
				api.GET(`website/${websiteGUID}/afpWebsite`)
					.then((res) => {
						localStorage.setItem("bcn-website-id", res?.item?.afp_website_id);
						resolve(true);
					}).catch(e => {
						console.log("Fetching AFP Adplatforms::catch", e);
						resolve(true);
					}).then(() => {
						getAllAdPlatforms();
					})
			resolve(true);
		});
	};

	const getDataForTodayPage = async () => {
		//increase total fetch count for each promise added here
		// setTotalFetchCount(totalFetchCount + 8);
		//you can add more promises here to load more data in parallel
		Promise.all(
			[
				BotDetailsData({ timeRange: 'Today' }, dispatch, 1),
				CurrentActivityPanelController({}, dispatch),
				GeographicalPanelController({
					timeRange: 'Prev 7 Days',
				}, dispatch),
				EvaluationPanelController({
					timeRange: 'Prev 7 Days',
				}, dispatch),
				AffiliatesController({
					timeRange: 'Prev 7 Days'
				}, dispatch),
				HumanActivityPanel({
					timeRange: "Prev 7 Days"
				}, dispatch)
			]
		).then((importA) => {
			//@todo remove below and move back to staggered loading
			dispatch(dashboardSelectedGraphs(importA));
			dispatch(loadDataForAllTabs(false))
			setReduxCompleteWTP(true)
		}).catch(e => {
			api.logout("Loading Failed", e);

		});
	};

	React.useLayoutEffect(() => {
		document.body.style.backgroundColor = "#662D91"
	});

	const getAllAdPlatforms = () => {
		//increase total fetch count for each promise added here
		// setTotalFetchCount(totalFetchCount + 2);
		bApi.getAdplatforms().then(ap => {
			let platformList = [];
			ap.map(i => {
				platformList.push(Adnetworks.filter(j => j.name === i[0])[0]);
			});
			dispatch({ type: "UPDATE_AVAILABLE_AD_NETWORKS", payload: platformList });
			//select first available network as default;
			dispatch({ type: "UPDATE_CURRENT_ADNETWORK", payload: [platformList?.[0]?.id ?? 1] });
			setReduxCompleteAFP(true);
		}).catch(e => {

		});
	};

	const requiredData = async () => {
		//increase total fetch count for each promise added here
		// setTotalFetchCount(totalFetchCount + 8);		
		Promise.all([
			ManageCustomerData({}, dispatch),
			TodayFinishedSessionsPanelController({}, dispatch),
			BlockedSessionsGeographyPanelController({
				timeRange: 'Prev 7 Days',
			}, dispatch),
			BlockedBotsCo2Controller({
				timeRange: 'Prev 7 Days'
			}, dispatch),
			FinishedSessionsPanelController({
				timeRange: 'Prev 7 Days',
			}, dispatch),
			BotRiskControllerforBotActivity({
				timeRange: 'Prev 7 Days'
			}, dispatch),
			BotRiskController({ timeRange: 'Prev 7 Days' }, dispatch, 1),
			BotTypeDescription({}, dispatch),
		]).then(() => {
			console.log("Required data fetch complete");
			getPageData();
			setRequiredDataReady(true);
			
		}).catch(e => {
			console.log("Required data fetch failed", e);
			setStateFailed(true);
		})
	}

	const getPageData = () => {
		if (detectModes.wtp_status !== "off" || isAdmin || isPartner) {
			getDataForTodayPage();
		} else {
			setReduxCompleteWTP(true);
		};		
		if (detectModes.afp_status !== "off") {
			getAFPWebsiteId();
		} else {
			setReduxCompleteAFP(true);
		};
	}

	React.useEffect(() => {
		requiredData();
	}, []);

	// return React.useMemo(() => {
	if (JSON.parse(status).Status === "Scheduled Maintenance") {
		return (
			<>
				<AppMaintenance status={status.MaintenanceMessage} />
			</>
		)
	};

	if (reduxCompleteWTP === false || reduxCompleteAFP === false || requiredDataReady === false) {		
			// const loadingProgress = Math.round((currentFetchCount / 18) * 100);
		return (
			<>
				<SelectHead />
				<Loading />
				{<div className="loading-error-msg">Hang tight! We're getting everything ready {".".repeat(loadingDots + 1)}</div>}
				<LoginFoot />
			</>

		)
	}
	if (reduxCompleteWTP && reduxCompleteAFP && requiredDataReady) {
		return (
			addWebThreatAllow || websiteDetails?.last_traffic === null ? <Navigate to="/wtp/bot-activity" /> : <Navigate to="/afp/current" />
		);
	};
	// }, [reduxCompleteWTP, reduxCompleteAFP]);
};

export default LoadingData;
